import { CsvOptions } from '@y42/json-schema';

export function getCsvOptions(): CsvOptions {
  return {
    field_delimiter: FieldDelimiter.Comma,
    allow_quoted_new_lines: true,
    null_marker: '',
    ignore_unknown_values: false,
    encoding: 'UTF-8',
    quote: '"',
  };
}

export enum FieldDelimiter {
  Comma = ',',
  Pipe = '|',
  Tab = '\t',
  Semicolon = ';',
}

export const FieldDelimiterTypes = [
  {
    value: FieldDelimiter.Comma,
    title: 'Comma',
  },
  {
    value: FieldDelimiter.Pipe,
    title: 'Pipe',
  },
  {
    value: FieldDelimiter.Tab,
    title: 'Tab',
  },
  {
    value: FieldDelimiter.Semicolon,
    title: 'Semicolon',
  },
];
